<template>
  <div
    class="fapi-float-price-container f-border f-rounded-md f-fixed f-bottom-3 f-z-10 f-px-2 f-py-1 f-mr-2 f-ml-2 float-price f-opacity-95 f-min-w-max"
    v-bind:style="{
      'max-width': floatPriceMaxWidth + 'px',
      right: floatPriceRight,
      left: floatPriceLeft,
      top: 'auto !important',
    }"
    v-show="showFloat"
  >
    <Prices
      :order="order"
      :discountCode="discountCode"
      :key="currency"
      :repayment="repayment"
      :repaymentCount="repaymentCount"
      :currency="currency"
      :showPricesIncludingVat="showPricesIncludingVat"
      :isChangeNameRepaymentToPayment="isChangeNameRepaymentToPayment"
      :installments="installments"
    ></Prices>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from "vue";
import Prices from "@/components/Form/Result/Prices.vue";
import OrderPrices from "@/module/Order/OrderPrices";
import { isFapiDiscountCodeOrNull } from "@/module/ComponentPropsValidations/validations";
import FormResource from "@/module/Form/Resources/FormResource";

export default Vue.extend({
  name: "FloatPrice",

  components: { Prices },

  props: {
    formResource: {
      type: Object as PropType<FormResource>,
      required: true,
    },
    currency: {
      type: String,
      required: true,
    },
    discountCode: {
      required: true,
      validator: isFapiDiscountCodeOrNull,
    },
    order: {
      type: Object as PropType<OrderPrices>,
      required: true,
    },
    repayment: {
      type: Boolean,
      required: true,
    },
    repaymentCount: {
      type: Number,
      required: true,
    },
    resultContainerId: {
      type: String,
      required: true,
    },
    showPricesIncludingVat: {
      type: Boolean,
      required: true,
    },
    isChangeNameRepaymentToPayment: {
      type: Boolean,
      required: true,
    },
    installments: {
      type: Array as PropType<InstallmentItem[]>,
      required: true,
    },
  },

  data(): any {
    return {
      showFloat: false,
      floatPriceMaxWidth: 0,
      floatPriceLeft: "auto !important",
      floatPriceRight: "auto !important",
      inForm: false,
      inPrice: false,
      formElement: {} as HTMLElement,
    };
  },

  methods: {
    calculateFloatPricePosition(): void {
      const vw = Math.min(
        document.documentElement.clientWidth || 0,
        window.innerWidth || 0,
      );

      const gapRight =
        vw -
        this.formElement.getBoundingClientRect().x -
        this.formElement.getBoundingClientRect().width;

      const gapLeft = this.formElement.getBoundingClientRect().x;

      this.floatPriceMaxWidth = this.formElement.getBoundingClientRect();

      this.formResource.styling?.float_price_position === "left"
        ? (this.floatPriceLeft = gapLeft + "px")
        : (this.floatPriceRight = gapRight + "px");
    },

    onPriceObserved(entries: Array<IntersectionObserverEntry>): void {
      entries.map((entry) => {
        this.inPrice = entry.isIntersecting;
      });

      this.trigger();
    },

    onFormObserved(entries: Array<IntersectionObserverEntry>) {
      entries.map((entry) => {
        this.inForm = entry.isIntersecting;
      });

      this.trigger();
    },

    trigger(): void {
      const vh = Math.max(
        document.documentElement.clientHeight || 0,
        window.innerHeight || 0,
      );

      this.showFloat = this.inForm && !this.inPrice && vh > 550;
      this.calculateFloatPricePosition();
    },
  },

  mounted(): void {
    this.formElement = this.$parent.$el as HTMLElement;
    const resultPriceContainer = document.getElementById(
      this.resultContainerId,
    );

    if (resultPriceContainer === null) {
      return;
    }

    new IntersectionObserver(this.onFormObserved).observe(this.formElement);
    new IntersectionObserver(this.onPriceObserved).observe(
      resultPriceContainer,
    );

    window.addEventListener("resize", () => {
      this.trigger();
    });

    this.trigger();
  },
});
</script>

<style lang="scss">
.fapi-order-form {
  .float-price {
    color: var(--float-price-color, var(--container-header-color));
    background-color: var(
      --float-price-background-color,
      var(--container-header-background-color)
    );
  }
}
</style>
